import { injectIntl } from "react-intl";
import { Button } from "antd";
import { Link } from "react-router-dom";
import RolesHelper from "../services/permisions/RolesHelper";
import { Auth } from "../services/Auth";

const NotFound = ({ intl }) => {
	// useEffect(() => {
	//   Auth.invalidateSession();
	// });
	if (RolesHelper.isAffilateUser()) {
		Auth.invalidateSession();
	}

	return (
		<div className="nf--container">
			<div className="nf--content">
				<h2>{intl.messages.notFoundHeader}</h2>
				<p>{intl.messages.notFoundTxt}</p>

				<Link to={RolesHelper.getRedirectPage()}>
					<Button type="primary" htmlType="submit" className="button">
						{intl.messages.goToHome}
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default injectIntl(NotFound);
